import React from "react";
import PropTypes from "prop-types";
import PhoneInput from "react-phone-number-input";

const FormikPhoneInput = React.forwardRef(
  ({ name, onChange,onSubmit, formik, ...rest }, ref) => (
    <PhoneInput {...rest} ref={ref} name={name} onChange={onChange} onSubmit={onSubmit} />
  )
);

FormikPhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formik: PropTypes.shape({
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired
  }).isRequired
};

export default FormikPhoneInput;
